<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/MachineReport/MachineDetail'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่ติดตั้ง(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="remdDateInstallStart"
                      name="remdDateInstallStart"
                      ref="remdDateInstallStart"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่ติดตั้ง(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="remdDateInstallEnd"
                      name="remdDateInstallEnd"
                      ref="remdDateInstallEnd"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่เริ่มสัญญาเช่า(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="remdContractStartDate_Start"
                      name="remdContractStartDate_Start"
                      ref="remdContractStartDate_Start"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่เริ่มสัญญาเช่า(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="remdContractStartDate_End"
                      name="remdContractStartDate_End"
                      ref="remdContractStartDate_End"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่หมดสัญญาเช่า(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="remdContractExpireDate_Start"
                      name="remdContractExpireDate_Start"
                      ref="remdContractExpireDate_Start"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่หมดสัญญาเช่า(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="remdContractExpireDate_End"
                      name="remdContractExpireDate_End"
                      ref="remdContractExpireDate_End"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <label>Agent:</label> -->
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'remdAgentCode'"
                    :name="'remdAgentCode'"
                    :select2-options="remdAgentCodeOptions"
                    multiple
                    v-model="remdAgentCode"
                  ></select2> -->
                  <treeselect
                    v-model="remdAgentCode"
                    :multiple="true"
                    :options="remdAgentCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Phase:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'remdPhase'"
                    :name="'remdPhase'"
                    :select2-options="remdPhaseOptions"
                    multiple
                    v-model="remdPhase"
                  ></select2> -->
                  <treeselect
                    v-model="remdPhase"
                    :multiple="true"
                    :options="remdPhaseOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Lot:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'remdLot'"
                    :name="'remdLot'"
                    :select2-options="remdLotOptions"
                    multiple
                    v-model="remdLot"
                  ></select2> -->
                  <treeselect
                    v-model="remdLot"
                    :multiple="true"
                    :options="remdLotOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทเครื่อง:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'remdMachineProductCode'"
                    :name="'remdMachineProductCode'"
                    :select2-options="remdMachineProductCodeOptions"
                    multiple
                    v-model="remdMachineProductCode"
                  ></select2> -->
                  <treeselect
                    v-model="remdMachineProductCode"
                    :multiple="true"
                    :options="remdMachineProductCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทหัวจ่าย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'remdDispenserProductCode'"
                    :name="'remdDispenserProductCode'"
                    :select2-options="remdDispenserProductCodeptions"
                    multiple
                    v-model="remdDispenserProductCode"
                  ></select2> -->
                  <treeselect
                    v-model="remdDispenserProductCode"
                    :multiple="true"
                    :options="remdDispenserProductCodeptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์เครื่องเบียร์สด:</label>
                  <!-- <label>Brand เครื่องเบียร์สด:</label> -->
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'remdMachineProductBrandId'"
                    :name="'remdMachineProductBrandId'"
                    :select2-options="remdMachineProductBrandIdOptions"
                    multiple
                    v-model="remdMachineProductBrandId"
                  ></select2> -->
                  <treeselect
                    v-model="remdMachineProductBrandId"
                    :multiple="true"
                    :options="remdMachineProductBrandIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์หัวจ่าย:</label>
                  <!-- <label>Brand หัวจ่าย:</label> -->
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'remdDispenserProductBrandId'"
                    :name="'remdDispenserProductBrandId'"
                    :select2-options="remdDispenserProductBrandIdOptions"
                    multiple
                    v-model="remdDispenserProductBrandId"
                  ></select2> -->
                  <treeselect
                    v-model="remdDispenserProductBrandId"
                    :multiple="true"
                    :options="remdDispenserProductBrandIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Supplier:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'remdSupplierId'"
                    :name="'remdSupplierId'"
                    :select2-options="remdSupplierIdOptions"
                    multiple
                    v-model="remdSupplierId"
                  ></select2> -->

                  <treeselect
                    v-model="remdSupplierId"
                    :multiple="true"
                    :load-options="LoadremdSupplierIdOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>จังหวัด:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'remdShopProvinceId'"
                    :name="'remdShopProvinceId'"
                    :select2-options="remdShopProvinceIdOptions"
                    multiple
                    v-model="remdShopProvinceId"
                  ></select2> -->
                  <treeselect
                    v-model="remdShopProvinceId"
                    :multiple="true"
                    :options="remdShopProvinceIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportMachineDetail"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="MachineDetailTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="29">
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ชื่อตัวแทนจำหน่าย</th>
                    <th class="all text-center">รหัสตัวแทนจำหน่าย</th>
                    <th class="all text-center">Phase</th>
                    <th class="all text-center">Lot</th>
                    <th class="all text-center">Supplier</th>
                    <th class="all text-center">ประเภทเครื่อง</th>
                    <th class="all text-center">จำนวน coil</th>
                    <th class="all text-center">BARCODE (เครื่องเบียร์สด)</th>
                    <th class="all text-center">แบรนด์เครื่องเบียร์สด</th>
                    <th class="all text-center">ประเภทหัวจ่าย</th>
                    <th class="all text-center">BARCODE (หัวจ่าย)</th>
                    <th class="all text-center">แบรนด์หัวจ่าย</th>
                    <th class="all text-center">วัน (ที่ติดตั้ง)</th>
                    <th class="all text-center">เดือน (ที่ติดตั้ง)</th>
                    <th class="all text-center">ปี (ที่ติดตั้ง)</th>
                    <th class="all text-center">วันที่เริ่มสัญญาเช่า</th>
                    <th class="all text-center">วันที่หมดสัญญาเช่า</th>
                    <th class="all text-center">การชำระค่างวด</th>
                    <th class="all text-center">ร้านค้า</th>
                    <th class="all text-center">ร้านค้า 2</th>
                    <th class="all text-center">ที่อยู่ร้านค้า</th>
                    <th class="all text-center">แขวง/ตำบล</th>
                    <th class="all text-center">จังหวัด</th>
                    <th class="all text-center">โทรศัพท์</th>
                    <th class="all text-center">Latitude</th>
                    <th class="all text-center">Longtitude</th>
                  </tr>
                </thead>
                <!-- <tfoot v-show="isShowFooter">
                    <tr>
                        <th class="text-right" colspan="6">จำนวนรวม</th>
                        <th class="text-center">{{TotalAmount}}</th> 
                        <th class="text-center" colspan="5"></th> 
                    </tr>
                </tfoot> -->
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      remdDateInstallStart: null,
      remdDateInstallEnd: null,
      remdContractStartDate_Start: null,
      remdContractStartDate_End: null,
      remdContractExpireDate_Start: null,
      remdContractExpireDate_End: null,
      remdAgentCode: [],
      remdPhase: [],
      remdLot: [],
      remdMachineProductCode: [],
      remdDispenserProductCode: [],
      remdMachineProductBrandId: [],
      remdDispenserProductBrandId: [],
      remdSupplierId: [],
      reAaIsInitial: true,
      reAaDateReq: null,
      reInv7: null,
      reAaProductTypeId: [],
      remdShopProvinceId: [],
      remdAgentCodeOptions: [],
      // remdAgentCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกAgent",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2Agent",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      remdMachineProductCodeOptions: [],
      // remdMachineProductCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทเครื่อง",
      //   allowClear: true,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         productTypeId: 3,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      remdDispenserProductCodeptions: [],
      // remdDispenserProductCodeptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทหัวจ่าย",
      //   allowClear: true,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         productTypeId: 6,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      remdDispenserProductBrandIdOptions: [],
      // remdDispenserProductBrandIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกBrand หัวจ่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2BrandMachine",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         ProductType: "6",
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      remdShopProvinceIdOptions: [],
      // remdShopProvinceIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกจังหวัด",
      //   ajax: {
      //     url: "/Api/MasterLocation/Select2SearchProvince",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      remdSupplierIdOptions: [],
      // remdSupplierIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกSupplier",
      //   allowClear: true,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Vendors/Select2Vendor",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      remdPhaseOptions: [],
      // remdPhaseOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกPhase",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterPhase/Select2Phase",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      remdLotOptions: [],
      // remdLotOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกLot",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterPhase/Select2Lot",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      remdMachineProductBrandIdOptions: [],
      // remdMachineProductBrandIdOptions: {
      //   placeholder: "กรุณาเลือกแบรนด์เครื่องเบียร์สด",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2BrandMachine",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         ProductType: [3],
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.remdDateInstallStart = null;
      self.remdDateInstallEnd = null;
      self.remdContractStartDate_Start = null;
      self.remdContractStartDate_End = null;
      (self.remdContractExpireDate_Start = null),
        (self.remdContractExpireDate_End = null),
        (self.remdAgentCode = []);
      self.remdPhase = [];
      self.remdLot = [];
      self.remdMachineProductCode = [];
      self.remdDispenserProductCode = [];
      self.remdMachineProductBrandId = [];
      self.remdDispenserProductBrandId = [];
      self.remdSupplierId = [];
      self.reInv7 = null;
      self.reAaProductTypeId = [];
      self.remdShopProvinceId = [];

      $("#remdAgentCode")
        .val("")
        .trigger("change");

      $("#remdPhase")
        .val("")
        .trigger("change");

      $("#remdLot")
        .val("")
        .trigger("change");

      $("#remdMachineProductCode")
        .val("")
        .trigger("change");

      $("#remdDispenserProductCode")
        .val("")
        .trigger("change");

      $("#remdMachineProductBrandId")
        .val("")
        .trigger("change");

      $("#remdDispenserProductBrandId")
        .val("")
        .trigger("change");

      $("#remdSupplierId")
        .val("")
        .trigger("change");

      $("#reAaProductTypeId")
        .val("")
        .trigger("change");

      $("#remdShopProvinceId")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      let self = this;

      e.preventDefault();
      var table = $("#MachineDetailTable").DataTable();
      table.draw();
    },
    exportMachineDetail: function(e) {
      e.preventDefault();
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportMachineDetail",
        responseType: "arraybuffer",
        data: {
          DateInstallStart:
            self.remdDateInstallStart != null
              ? self.remdDateInstallStart.format("DD/MM/YYYY")
              : self.remdDateInstallStart,
          DateInstallEnd:
            self.remdDateInstallEnd != null
              ? self.remdDateInstallEnd.format("DD/MM/YYYY")
              : self.remdDateInstallEnd,
          ContractStartDate_Start:
            self.remdContractStartDate_Start != null
              ? self.remdContractStartDate_Start.format("DD/MM/YYYY")
              : self.remdContractStartDate_Start,
          ContractStartDate_End:
            self.remdContractStartDate_End != null
              ? self.remdContractStartDate_End.format("DD/MM/YYYY")
              : self.remdContractStartDate_End,
          ContractExpireDate_Start:
            self.remdContractExpireDate_Start != null
              ? self.remdContractExpireDate_Start.format("DD/MM/YYYY")
              : self.remdContractExpireDate_Start,
          ContractExpireDate_End:
            self.remdContractExpireDate_End != null
              ? self.remdContractExpireDate_End.format("DD/MM/YYYY")
              : self.remdContractExpireDate_End,
          AgentCode: self.remdAgentCode,
          Phase: self.remdPhase,
          Lot: self.remdLot,
          MachineProductCode: self.remdMachineProductCode,
          DispenserProductCode: self.remdDispenserProductCode,
          MachineProductBrandId: self.remdMachineProductBrandId,
          DispenserProductBrandId: self.remdDispenserProductBrandId,
          SupplierId: self.remdSupplierId,
          ShopProvinceId: self.remdShopProvinceId,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadremdAgentCodeOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Report/Select2Agent", {
          province_id: [],
          department: [],
          AgentCodes: [],
          page: 1,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.remdAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadremdMachineProductCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            productTypeId: 3,
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.remdMachineProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadremdDispenserProductCodeptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            productTypeId: 6,
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.remdDispenserProductCodeptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadremdDispenserProductBrandIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2BrandMachine", {
          params: {
            ProductType: 6,
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.remdDispenserProductBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadremdShopProvinceIdOptions: function(e) {
      var self = this;
      axios
        .post("/Api/MasterLocation/Select2SearchProvince", {
          all: true,
          page: 1,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.remdShopProvinceIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadremdSupplierIdOptions({ action, searchQuery, callback }) {
      var self = this;
      self.remdSupplierIdOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Vendors/Select2Vendor", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.remdSupplierIdOptions = [];
              data.forEach((element) => {
                self.remdSupplierIdOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.remdSupplierIdOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadremdPhaseOptions: function(e) {
      var self = this;
      axios
        .get("/Api/MasterPhase/Select2Phase", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.remdPhaseOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadremdLotOptions: function(e) {
      var self = this;
      axios
        .post("/Api/MasterPhase/Select2Lot", {
          page: 1,
          Phases: self.remdPhase,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            //console.log("data", data);
            self.remdLotOptions = [];
            data.forEach((element) => {
              self.remdLotOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadremdMachineProductBrandIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2BrandMachine", {
          params: {
            page: 1,
            ProductType: [3],
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.remdMachineProductBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;

    self.LoadremdAgentCodeOptions();
    self.LoadremdMachineProductCodeOptions();
    self.LoadremdDispenserProductCodeptions();
    self.LoadremdDispenserProductBrandIdOptions();
    self.LoadremdShopProvinceIdOptions();

    self.LoadremdPhaseOptions();
    self.LoadremdLotOptions();
    self.LoadremdMachineProductBrandIdOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.remdDateInstallStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.remdDateInstallStart)
      .datepicker(
        "update",
        !!self.remdDateInstallStart
          ? self.remdDateInstallStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.remdDateInstallStart = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.remdDateInstallEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.remdDateInstallEnd)
      .datepicker(
        "update",
        !!self.remdDateInstallEnd
          ? self.remdDateInstallEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.remdDateInstallEnd = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.remdContractStartDate_Start).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.remdContractStartDate_Start)
      .datepicker(
        "update",
        !!self.remdContractStartDate_Start
          ? self.remdContractStartDate_Start.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.remdContractStartDate_Start =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.remdContractStartDate_End).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.remdContractStartDate_End)
      .datepicker(
        "update",
        !!self.remdContractStartDate_End
          ? self.remdContractStartDate_End.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.remdContractStartDate_End =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.remdContractExpireDate_Start).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.remdContractExpireDate_Start)
      .datepicker(
        "update",
        !!self.remdContractExpireDate_Start
          ? self.remdContractExpireDate_Start.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.remdContractExpireDate_Start =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.remdContractExpireDate_End).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.remdContractExpireDate_End)
      .datepicker(
        "update",
        !!self.remdContractExpireDate_End
          ? self.remdContractExpireDate_End.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.remdContractExpireDate_End =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#MachineDetailTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/MachineDetail",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              DateInstallStart:
                self.remdDateInstallStart != null
                  ? self.remdDateInstallStart.format("DD/MM/YYYY")
                  : self.remdDateInstallStart,
              DateInstallEnd:
                self.remdDateInstallEnd != null
                  ? self.remdDateInstallEnd.format("DD/MM/YYYY")
                  : self.remdDateInstallEnd,
              ContractStartDate_Start:
                self.remdContractStartDate_Start != null
                  ? self.remdContractStartDate_Start.format("DD/MM/YYYY")
                  : self.remdContractStartDate_Start,
              ContractStartDate_End:
                self.remdContractStartDate_End != null
                  ? self.remdContractStartDate_End.format("DD/MM/YYYY")
                  : self.remdContractStartDate_End,
              ContractExpireDate_Start:
                self.remdContractExpireDate_Start != null
                  ? self.remdContractExpireDate_Start.format("DD/MM/YYYY")
                  : self.remdContractExpireDate_Start,
              ContractExpireDate_End:
                self.remdContractExpireDate_End != null
                  ? self.remdContractExpireDate_End.format("DD/MM/YYYY")
                  : self.remdContractExpireDate_End,
              AgentCode: self.remdAgentCode,
              Phase: self.remdPhase,
              Lot: self.remdLot,
              MachineProductCode: self.remdMachineProductCode,
              DispenserProductCode: self.remdDispenserProductCode,
              MachineProductBrandId: self.remdMachineProductBrandId,
              DispenserProductBrandId: self.remdDispenserProductBrandId,
              SupplierId: self.remdSupplierId,
              ShopProvinceId: self.remdShopProvinceId,
              IsInitial: self.reAaIsInitial
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [100, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[1, "desc"]],
        columns: [
          { data: "agentName", className: "text-center" },
          { data: "agentCode", className: "text-center" },
          { data: "phase", className: "text-center" },
          { data: "lot", className: "text-center" },
          { data: "supplierName", className: "text-center" },
          { data: "machineProductName", className: "text-center" },
          { data: "qtyCoil", className: "text-center" },
          { data: "machineBarcodeOldNo", className: "text-center" },
          { data: "machineProductBrandName", className: "text-center" },
          { data: "dispenserProductName", className: "text-center" },
          { data: "dispenserBarcodeOldNo", className: "text-center" },
          { data: "dispenserProductBrandName", className: "text-center" },
          { data: "dateInstallDay", className: "text-center" },
          { data: "dateInstallMonth", className: "text-center" },
          { data: "dateInstallYear", className: "text-center" },
          { data: "contractStartDateString", className: "text-center" },
          { data: "contractExpireDateString", className: "text-center" },
          { data: "paymentInstallment", className: "text-center" },
          { data: "shopName", className: "text-center" },
          { data: "shopName2", className: "text-center" },
          { data: "shopAddress", className: "text-center" },
          { data: "shopTambonName", className: "text-center" },
          { data: "shopProvinceName", className: "text-center" },
          { data: "shopTelephone", className: "text-center" },
          { data: "latitude", className: "text-center" },
          { data: "longitude", className: "text-center" },
        ],
        drawCallback: function(settings) {
          self.reAaIsInitial = false;
          self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

          // var allPage = table.DataTable().page.info().pages;
          // var currentPage = table.DataTable().page.info().page +1;

          // self.isShowFooter = false;
          // self.TotalAmount = 0;

          // if(allPage == currentPage){
          //   self.isShowFooter = true;
          //   self.TotalAmount = settings.json.data[0].totalAmount;
          // }
        },
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
  watch: {
    remdPhase: function() {
      //console.log(this.remdPhase);
      this.LoadremdLotOptions();
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/MachineDetail.vue